
document.addEventListener('DOMContentLoaded', function ()
{
    const wrapperEls = document.querySelectorAll('.faq-wrapper')
    for (const wrapperEl of wrapperEls)
    {
        init(wrapperEl)
    }

    function init (wrapperEl)
    {
        const questionEl = wrapperEl.querySelector('.question')
        const answerEl = wrapperEl.querySelector('.answer')
        
        let answerHeight = 0;
        let resizeTimeout = null

        function resetWrapper ()
        {
            wrapperEl.classList.remove('animations-active')
            answerEl.style.height = 'auto'
            answerHeight = answerEl.clientHeight
            if (wrapperEl.classList.contains('folded'))
            {
                answerEl.style.height = 0
            }
            else
            {
                answerEl.style.height = answerHeight
            }
            wrapperEl.classList.add('animations-active')
        }

        function toggle ()
        {
            console.log('toggle')
            console.log(answerHeight)
            if (wrapperEl.classList.contains('folded'))
            {
                wrapperEl.classList.remove('folded')
                answerEl.style.height = answerHeight+'px'
            }
            else
            {
                wrapperEl.classList.add('folded')
                answerEl.style.height = 0
            }
        }

        wrapperEl.classList.add('folded')
        window.addEventListener('resize', () => {
            clearTimeout(resizeTimeout);
            resizeTimeout = setTimeout(() => {
                resetWrapper()
            }, 500)
        })
        questionEl.addEventListener('click', () => toggle())
        resetWrapper()

        
    }

});
